export default __webpack_public_path__ + "static/media/quote-table.c0b81697.png";